import { openProcedureReceiptPdf, openCombinedReceiptPdf } from './api/patientPlanApi';

function alertReceiptFailure(receipt) {
  if (receipt && receipt.success === false) {
    // eslint-disable-next-line no-alert
    window.alert(
      (receipt.error || 'Payment was collected, but the receipt could not be opened.')
      + ' You can reprint it from the payment list.',
    );
  }
}

/**
 * Open the procedure receipt PDF for a successful collect-payment result,
 * surfacing failures instead of swallowing them.
 *
 * Every collect surface (the doctor/receptionist widgets via
 * useSittingActions, and the receptionist bulk/inline collect in
 * ReceptionistTaskWidget) should call this so a receipt always follows a
 * collected payment and a failed receipt is never silent.
 *
 * @param {{success?: boolean, data?: {payment_id?: string}}} result
 *   The result returned by the collectPayment store action / API.
 */
export async function openReceiptForCollectResult(result) {
  if (!result?.success || !result.data?.payment_id) return;
  const receipt = await openProcedureReceiptPdf(result.data.payment_id);
  alertReceiptFailure(receipt);
}

/**
 * Open the receipt for a bundled collect that produced one or more payments
 * sharing a single receipt number. Multiple payment_ids → ONE combined
 * receipt listing every procedure; a single id → its single receipt.
 *
 * @param {string[]} batchPaymentIds  payment_ids returned by collectBundledPayment
 */
export async function openReceiptForBatch(batchPaymentIds) {
  const ids = (batchPaymentIds || []).filter(Boolean);
  if (ids.length === 0) return;
  const receipt = ids.length === 1
    ? await openProcedureReceiptPdf(ids[0])
    : await openCombinedReceiptPdf(ids);
  alertReceiptFailure(receipt);
}
